module.exports = __webpack_public_path__ + "static/sc_2-b2b3c81f4fa447dc86b2419993dc6a76.jpg";